module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderDetail"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("订单详情-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  })]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "payState"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.payment1),
        expression: "payment1"
      }],
      staticClass: "state"
    }, [_c('p', {
      staticClass: "stateText"
    }, [_vm._v("待支付")]), _vm._v(" "), _c('span', {
      staticClass: "countDown",
      attrs: {
        "id": "countDown"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Immediate"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'PaymentOrder',
          params: {
            id: item.order_id
          }
        }
      }
    }, [_vm._v("立即支付")])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.payment2),
        expression: "payment2"
      }],
      staticClass: "state"
    }, [_c('p', {
      staticClass: "stateText"
    }, [_vm._v("待审核")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.payment3),
        expression: "payment3"
      }],
      staticClass: "state"
    }, [_c('p', {
      staticClass: "stateText"
    }, [_vm._v("已付款")]), _vm._v(" "), _c('div', {
      staticClass: "Immediate"
    }, [(_vm.zhShenQing) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ApplyInvoice',
          params: {
            id: item.order_id
          }
        }
      }
    }, [_vm._v("申请发票")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.payment4),
        expression: "payment4"
      }],
      staticClass: "state"
    }, [_c('p', {
      staticClass: "stateText"
    }, [_vm._v("已关闭")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.payment5),
        expression: "payment5"
      }],
      staticClass: "state"
    }, [_c('p', {
      staticClass: "stateText"
    }, [_vm._v("已取消")])]), _vm._v(" "), _c('div', {
      staticClass: "orderCon"
    }, [_vm._v("订单信息")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "payNumber"
    }, [_c('p', {
      staticClass: "orderNumber"
    }, [_vm._v("订单编号："), _c('span', [_vm._v(_vm._s(item.order_id))])]), _vm._v(" "), _c('p', {
      staticClass: "orderTime"
    }, [_vm._v("下单时间："), _c('span', [_vm._v(_vm._s(item.order_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "detailed"
    }, [_c('div', {
      staticClass: "contentImg"
    }, [_c('img', {
      attrs: {
        "src": item.img_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contentTitle"
    }, [_c('h2', {
      staticClass: "orderTitle"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v("开班地点："), _c('span', [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('p', [_vm._v("开班时间："), _c('span', [_vm._v(_vm._s(item.classes_begin) + "至" + _vm._s(item.classes_end))])])]), _vm._v(" "), _c('div', {
      staticClass: "payMoney"
    }, [_c('p', {
      staticClass: "actual"
    }, [_vm._v("实付金额")]), _vm._v(" "), _c('p', {
      staticClass: "moneyNum"
    }, [_vm._v("￥" + _vm._s(item.unit_price))]), _vm._v(" "), _c('p', {
      staticClass: "sum"
    }, [_vm._v("金额明细")])]), _vm._v(" "), _c('div', {
      staticClass: "clears"
    }), _vm._v(" "), _c('ul', {
      staticClass: "floatDetail"
    }, [(item.price_type == '市场价' ? false : true) ? _c('li', [_vm._v("市场价"), _c('span', [_vm._v("￥" + _vm._s(item.market_price))])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.price_type)), _c('span', [_vm._v("￥" + _vm._s(item.payment))])]), _vm._v(" "), _c('li', [_vm._v("报名人数"), _c('span', [_vm._v("×" + _vm._s(item.order_num))])]), _vm._v(" "), _c('li', [_vm._v("抵扣奖学金"), _c('span', [_vm._v("￥" + _vm._s(item.scholarship))])]), _vm._v(" "), _c('li', [_vm._v("优惠券"), _c('span', [_vm._v("￥" + _vm._s(item.coupon_price))])]), _vm._v(" "), _c('li', {
      staticClass: "BasePrice"
    }, [_vm._v("学费抵扣"), _c('b', {
      staticClass: "integ"
    }, [_vm._v("(积分-" + _vm._s(item.integral) + ")")]), _c('span', [_vm._v("￥" + _vm._s(item.tuition))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "applicant"
    }, [_c('p', {
      staticClass: "peopleInfo"
    }, [_vm._v("报名人信息")]), _vm._v(" "), _c('ul', {
      staticClass: "field"
    }, [_c('li', {
      staticClass: "fullName"
    }, [_vm._v("姓名")]), _vm._v(" "), _c('li', {
      staticClass: "handPhone"
    }, [_vm._v("手机")]), _vm._v(" "), _c('li', {
      staticClass: "ident"
    }, [_vm._v(_vm._s(_vm.shenfen))]), _vm._v(" "), (_vm.huzhao == 1 ? false : true) ? _c('li', {
      staticClass: "passport"
    }, [_vm._v("护照号")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clears"
    }), _vm._v(" "), _vm._l((_vm.Applicant), function(item) {
      return _c('ul', {
        staticClass: "field2"
      }, [_c('li', {
        staticClass: "fullName"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('li', {
        staticClass: "handPhone"
      }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('li', {
        staticClass: "ident"
      }, [_vm._v(_vm._s(item.identity))]), _vm._v(" "), (_vm.huzhao == 1 ? false : true) ? _c('li', {
        staticClass: "passport"
      }, [_vm._v(_vm._s(item.passport_id))]) : _vm._e()])
    }), _vm._v(" "), _vm._l((_vm.list), function(item) {
      return _c('div', {
        staticClass: "clears"
      })
    }), _vm._v(" "), _c('h1', {
      staticClass: "contactInfo"
    }, [_vm._v("联系人信息")]), _vm._v(" "), _c('p', {
      staticClass: "contactPeople"
    }, [_vm._v("姓名"), _c('span', [_vm._v(_vm._s(item.o_name))])]), _vm._v(" "), _c('p', {
      staticClass: "contactPeople"
    }, [_vm._v("手机"), _c('span', [_vm._v(_vm._s(item.mobile))])])], 2)])
  }), _vm._v(" "), _c('Bottom')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abd7df4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderDetail/orderDetail.vue
// module id = 564
// module chunks = 1